import { render } from "./SubTitle1.vue?vue&type=template&id=51d9d0d0&scoped=true"
import script from "./SubTitle1.vue?vue&type=script&lang=js"
export * from "./SubTitle1.vue?vue&type=script&lang=js"

import "./SubTitle1.vue?vue&type=style&index=0&id=51d9d0d0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51d9d0d0"]])

export default __exports__